import { FC, PropsWithChildren } from 'react';

import { IonRow } from '@ionic/react';

import { GridRowContext } from '../Grid.context';

type GridRowProps = PropsWithChildren<{
  spacing?: number;
}>;

export const GridRow: FC<GridRowProps> = ({ children, spacing = 0 }) => {
  return (
    <GridRowContext.Provider value={{ spacing }}>
      <IonRow>{children}</IonRow>
    </GridRowContext.Provider>
  );
};
